jQuery(function($){
  var $container = $('#tours-container');
  $container.on('click', '.pager a', function(e){
    e.preventDefault();
    $container.find('.tour').animate({ 'opacity': 0 });
    $container.load(this.href + ' #tours-container', function(){
      $container.find('.tour').css({ 'opacity': 0 }).animate({ 'opacity': 1 });
    });
  });
});